import FilterForm from 'components/forms/FilterForm';
import React from 'react';
import { Col, DatePicker, Form, FormProps, Input, Row, Select } from 'antd';
import { IFilter } from './PendingCertificates';
import { IGraduateCourse } from 'interfaces/graduate_courses';
import { useSelect } from '@refinedev/antd';

export interface PendingCertificatesFilterProps {
  searchFormProps: FormProps<IFilter>;
}

export const PendingCertificatesFilter = ({
  searchFormProps
}: PendingCertificatesFilterProps) => {
  const { selectProps: courseSelectProps } = useSelect<IGraduateCourse>({
    resource: 'graduate_courses',
    optionLabel: 'name',
    optionValue: 'id',

    onSearch: value => [
      {
        field: 'filter[name]',
        operator: 'eq',
        value
      }
    ],

    pagination: {
      mode: 'server'
    }
  });
  return (
    <FilterForm searchFormProps={searchFormProps}>
      <Row gutter={[16, 16]} className="w-full flex items-end">
        <Col span={8}>
          <Form.Item label="Nome do aluno" name="search_user_name">
            <Input placeholder="Nome do aluno" />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item label="Número da matrícula" name="by_registration">
            <Input placeholder="Número da matrícula" />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item label="CPF" name="by_cpf">
            <Input placeholder="Somente números" />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={[16, 16]} className="w-full flex items-end">
        <Col span={8}>
          <Form.Item label="Curso" name="by_course_id">
            <Select {...courseSelectProps} placeholder="Somente números" />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item label="Data de inicío (á partir de)" name="started_after">
            <DatePicker
              className="w-full"
              placeholder="dia/mês/ano"
              format="DD/MM/YYYY"
              picker="date"
            />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item label="Data de inicío (até)" name="started_before">
            <DatePicker
              className="w-full"
              placeholder="dia/mês/ano"
              format="DD/MM/YYYY"
              picker="date"
            />
          </Form.Item>
        </Col>
      </Row>
    </FilterForm>
  );
};
